// extracted by mini-css-extract-plugin
export default {"fulscreenContainer":"FullScreenDisplay_fulscreenContainer__9y9Sw"};